type Item = {
  enabled: boolean;
  min: number;
  max: number;
};

export const normalizeCurrencyMinMax = (array: Item[]) => {
  const validItems = array.filter((item) => item.enabled);
  const mins = validItems.map((item) => item.min);
  const maxs = validItems.map((item) => item.max);

  return {
    currencyMin: Math.min(...mins),
    currencyMax: Math.max(...maxs),
  };
};
